import { cn } from "@/lib/utils";

/**
 * Carte produit en état skeleton / placeholder.
 * Garde le même ratio et le même blanc textuel qu'un ProductCard réel pour éviter tout saut de layout.
 */
export function ProductPlaceholderCard({ className }: { className?: string }) {
  return (
    <article className={cn("group", className)}>
      <div className="relative aspect-[4/5] overflow-hidden bg-sand">
        <div className="skeleton-shimmer absolute inset-0 h-full w-full" aria-hidden="true" />
      </div>

      <div className="mt-4 flex h-16 items-start justify-between gap-3">
        <div className="flex h-full min-w-0 flex-col justify-between">
          <div className="skeleton-shimmer h-5 w-32 rounded-sm" />
          <div className="skeleton-shimmer h-4 w-20 rounded-sm" />
        </div>
        <div className="skeleton-shimmer h-4 w-14 rounded-sm pt-0.5" />
      </div>
    </article>
  );
}
